export default __webpack_public_path__ + "static/SectionTwo_01_02-0751656702d3ffefa260076b4a81bae3.png";